import { ItemStates } from '@utility/constants/common';

/* An alias the 3PL reports stock for that no catalog item holds yet. */
export type UnmatchedAlias = {
  alias: string;
  available?: number;
};

/* The catalog rows the autocomplete returns for an alias match. */
export type AliasMatchItem = {
  _id: string;
  p_title?: string;
  short_title?: string;
  p_sku?: string;
  p_price?: number;
  p_currency?: string;
  p_images?: { display_image?: string };
  state?: string;
};

/** An item still in conflict has to be resolved before an alias joins it. */
export function isUnmatchable(item: AliasMatchItem) {
  return item.state === ItemStates.conflict;
}
